var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1,
    y: 1,
    width: 153,
    height: 153,
    rx: 21,
    fill: "#FEF3C7",
    stroke: "#D97706",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5434 116.361C32.1975 117.457 32.2755 118.642 32.7622 119.682C33.2488 120.723 34.1082 121.543 35.1705 121.98C36.2329 122.417 37.4207 122.439 38.4988 122.042L49.7867 117.883C51.1037 117.412 52.5635 117.565 53.7545 118.298C64.0587 124.485 76.2623 126.71 88.0873 124.559C99.9123 122.407 110.549 116.025 118.014 106.605C125.478 97.1842 129.259 85.3702 128.651 73.3664C128.042 61.3627 123.086 49.9905 114.707 41.3739C106.328 32.7565 95.1007 27.4827 83.1181 26.5385C71.1363 25.5935 59.2206 29.0415 49.5946 36.2387C39.9687 43.436 33.2908 53.89 30.8076 65.6499C28.325 77.4099 30.2067 89.6712 36.102 100.145C36.7401 101.244 36.8905 102.56 36.517 103.775L32.5434 116.361ZM64.3013 67.784C63.429 66.9272 62.9353 65.7574 62.9299 64.5349C62.9241 63.3124 63.4075 62.138 64.272 61.2736C65.1364 60.4092 66.3108 59.9258 67.5333 59.9315C68.7557 59.9369 69.9256 60.4306 70.7824 61.3029L79.0001 69.5207L87.2179 61.3029C88.0755 60.4342 89.2442 59.9441 90.4645 59.9401C91.6849 59.9362 92.8565 60.4196 93.7194 61.2826C94.5824 62.1455 95.0655 63.3171 95.0615 64.5375C95.0579 65.7581 94.5674 66.9265 93.6991 67.7841L85.4813 76.0019L93.6991 84.2196C94.5678 85.0772 95.0579 86.2459 95.0619 87.4662C95.0658 88.6866 94.5824 89.8582 93.7194 90.7211C92.8565 91.5841 91.6849 92.0672 90.4645 92.0632C89.2439 92.0596 88.0755 91.5691 87.2179 90.7008L79.0001 82.4831L70.7824 90.7008C69.9248 91.5695 68.7561 92.0597 67.5358 92.0636C66.3154 92.0675 65.1438 91.5841 64.2809 90.7211C63.4179 89.8582 62.9348 88.6866 62.9388 87.4662C62.9423 86.2456 63.4329 85.0772 64.3012 84.2196L72.5189 76.0019L64.3013 67.784Z",
    fill: "#D97706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReach);
export default __webpack_public_path__ + "static/media/noReach.e9dc4970b87a32c40c2d57c05d3e3316.svg";
export { ForwardRef as ReactComponent };